import '../../app.es6';
import angular from 'angular';

class MemberSignInController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location,
    commonAuthFactory, commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$location = $location;
    this.commonAuthFactory = commonAuthFactory;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_SMALL_HEIGHT] = '';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$sessionStorage[this.Const.SSAPP_FULL_SCREEN_IOS] = false;
    this.isFailed = false;
    this.isLimit = false;
    Page.setTitle(this.Const.TITLE.signIn);
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    let sessionRole = this.$sessionStorage[Const.LSAPP_ROLE];
    let role = localStorage.getItem(Const.LSAPP_ROLE);
    // Cognito Credentials
    let userId = localStorage.getItem(Const.LSKEY_USER_ID);
    let jwtToken = localStorage.getItem(Const.LSKEY_USER_ID_TOKEN);
    let accessKeyId = localStorage.getItem(Const.LSKEY_USER_ACCESS_KEY_ID);
    let secretAccessKey = localStorage.getItem(Const.LSKEY_USER_SECRET_ACCESS_KEY);
    let sessionToken = localStorage.getItem(Const.LSKEY_USER_SESSION_TOKEN);
    let refreshToken = localStorage.getItem(Const.LSKEY_USER_REFRESH_TOKEN);
    let accessToken = localStorage.getItem(Const.LSKEY_USER_ACCESS_TOKEN);
    let isCredential = false;
    if (userId && jwtToken && accessKeyId && secretAccessKey && sessionToken && refreshToken && accessToken) {
      isCredential = true;
    }
    if ((!sessionRole && role && isCredential) && role === this.Const.LSAPP_ROLE_MEMBER) {
      this.simplicitySignIn();
    }

    MemberSignInController.$inject = [
      '$scope', '$sessionStorage', '$location',
      'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  signIn () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.isFailed = false;
    this.isLimit = false;

    let id = this.userId;
    let password = this.userPass;
    let userAuth = this.commonAuthFactory.userLogin(id, password, null);
    this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_MEMBER);
    userAuth.then((userCredentials) => {
      return this.commonAuthFactory.getCredentialsForAPI(userCredentials, localStorage.getItem(this.Const.LSAPP_ROLE));
    })
    .then(() => {
      return this.commonApiFactory.getMembersMe();
    })
    .then((member) => {
      // 生徒情報を追加時に他修正が必要な箇所
      // ・password-change-controller.es6
      // ・simplicity-sign-in-controller.es6
      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
      this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
      this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
      this.$sessionStorage[this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
      this.$sessionStorage[this.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
      if (member.data.eulaAgree !== null &&
        member.data.eulaAgree === this.Const.EULA_AGREE_TYPE.agreed) {
        this.$location.path('/member');
      } else {
        this.$location.path('/eula');
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.log('error : ', error);
      if (error) {
        if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
          this.isFailed = false;
          this.isLimit = true;
        } else {
          this.isFailed = true;
          this.isLimit = false;
        }
      } else {
        this.isFailed = true;
        this.isLimit = false;
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  simplicitySignIn () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.isFailed = false;
    this.isLimit = false;

    this.commonApiFactory.getMembersMe()
    .then((member) => {
      this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_MEMBER);
      // 生徒情報を追加時に他修正が必要な箇所
      // ・password-change-controller.es6
      // ・simplicity-sign-in-controller.es6
      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
      this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
      this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
      this.$sessionStorage[this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
      this.$sessionStorage[this.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
      this.$location.path('/member');
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.log('error : ', error);
      if (error) {
        if (error.statusCode === 400 && ~error.message.indexOf('attempts exceeded')) {
          this.isFailed = false;
          this.isLimit = true;
        } else {
          this.isFailed = true;
          this.isLimit = false;
        }
      } else {
        this.isFailed = true;
        this.isLimit = false;
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  toPasswordForget () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/password_forget');
  }
}

angular.module('myApp').controller('MemberSignInController', MemberSignInController);



// WEBPACK FOOTER //
// ./app/components/member-sign-in/member-sign-in-controller.es6